import bem from '../../../../utils/bem';
import Modal from '../../Modal';

const RemoveContractorModal = (props) => {
  const { title, onRemoveHandler, modalId, onCancelHandler, onCloseHandler } =
    props;
  return (
    <Modal
      modal_id={modalId}
      modalModifiers={[]}
      variantClassic={true}
      widthSmall={true}
      centered={true}
      onCloseHandler={onCloseHandler}
    >
      <div className={'modal__content flex flex-col'}>
        <h3 className={'modal__title modal__title--blue'}>
          {Drupal.t('Are you sure?')}
        </h3>
        <div className={'modal__description'}>
          {Drupal.t(`Are you sure you want to remove ${title}?`)}
        </div>
        <div className={'modal__actions'}>
          <button
            type="button"
            onClick={() => onRemoveHandler()}
            className={bem('btn', [], '', ['js-modal-close'])}
          >
            {Drupal.t('Remove')}
          </button>
          <button
            type="button"
            className={bem('btn', ['secondary', 'cancel'], '', [
              'js-modal-close',
            ])}
            onClick={(e) => onCancelHandler?.(e)}
          >
            {Drupal.t('Cancel')}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RemoveContractorModal;
